import React from 'react';

export default class MenuItem extends React.Component {
    render() {
        const { title, onClick, active } = this.props;

        const baseClass = "btn w-100 text-start";
        const colorClass = active ? "btn-primary" : "btn-outline-primary";

        return (
            <div class="mb-2">
                <button
                    type="button"
                    class={`${baseClass} ${colorClass}`}
                    onClick={onClick}
                    style={{ borderRadius: '8px', fontWeight: active ? 600 : 400 }}
                >
                    {title}
                </button>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/ui/menu-item.js